import { render } from "./licenseClasses.vue?vue&type=template&id=731864da&scoped=true"
import script from "./licenseClasses.vue?vue&type=script&lang=js"
export * from "./licenseClasses.vue?vue&type=script&lang=js"

import "./licenseClasses.vue?vue&type=style&index=0&id=731864da&scoped=true&lang=css"
import "./licenseClasses.vue?vue&type=style&index=1&id=731864da&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731864da"]])

export default __exports__